import { map, type OperatorFunction } from 'rxjs';

import { type PaginatedListResponse } from '../types';

export interface MapPaginatedListOptions {
  skipInvalid?: boolean;
}

export function mapPaginatedList<TDto, T = TDto>(
  mapper?: (dto: TDto) => T,
  options?: MapPaginatedListOptions,
): OperatorFunction<PaginatedListResponse<TDto>, PaginatedListResponse<T>> {
  return map((response) => {
    if (!mapper) {
      return { data: response.data as unknown as T[], pagination: response.pagination };
    }

    if (!options?.skipInvalid) {
      return { data: response.data.map(mapper), pagination: response.pagination };
    }

    const data: T[] = [];

    for (const dto of response.data) {
      try {
        data.push(mapper(dto));
      } catch (error) {
        console.error('[mapPaginatedList] skipping invalid item', error, 'Raw payload:', dto);
      }
    }

    return { data, pagination: response.pagination };
  });
}
